import { usePaginatedApi } from "../../../swr/useApi";
import { documentsService } from "../../api_client";
import type { UserDocumentsDto, DocumentsQueryDto } from "../../../api";
import { DocumentsQueryDtoStatusEnum } from "../../../api";

export function useAdminDashboardDocuments() {
  return usePaginatedApi<UserDocumentsDto, DocumentsQueryDto>({
    key: "admin-dashboard-documents",
    serviceMethod: async (query) => documentsService.getDocumentsGroupedByUser(query),
    query: { status: DocumentsQueryDtoStatusEnum.Pending, page: 1, pageSize: 3 },
  });
}
